import { Box, Button, Typography } from '@mui/material';
import { useStyles } from 'components/Styles';
import React from 'react';

export default function WelcomeText(props) {
  const { setStep } = props;
  const classes = useStyles();

  return (
    <section style={{ display: 'grid', gap: '4.5rem' }}>
      <Typography
        style={{ marginBottom: '1rem', fontWeight: '700', fontSize: '40px' }}
      >
        Vamos configurar um viveiro!
      </Typography>
      <Typography style={{ textAlign: 'center', marginBottom: '1rem', fontSize: '22px' }}>
        Agora vamos ajuda-ló a criar um viveiro.
      </Typography>
      <div style={{ display: 'grid', justifyItems: 'center' }}>
        <Button
          className={classes.roundedButton}
          style={{ width: '50%' }}
          variant="contained"
          size="large"
          onClick={() => {
            setStep((prev) => prev + 1);
          }}
          fullWidth
        >
          <Typography variant="button" style={{ textTransform: 'none' }}>Criar viveiro</Typography>
        </Button>
      </div>
    </section>
  );
}
